"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var CustomerResource = /** @class */ (function (_super) {
    tslib_1.__extends(CustomerResource, _super);
    function CustomerResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomerResource.endpoint = '/customers';
    CustomerResource.MODEL_NAME = 'customer';
    return CustomerResource;
}(base_1.default));
exports.default = CustomerResource;
//# sourceMappingURL=customer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/customer.js
// module id = 3ob3
// module chunks = 0